export const WEBSITE_LINK = /^(ftp|http|https):\/\/[^ "]+$/;
export const IS_VALID_EMAIL = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
